// 格式化日期
function format (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (date != null) {
    // 字符串，先转成日期类型
    if (typeof date === 'string') {
      date = new Date(date.replace(/-/g, '/'))
    }
    // 时间戳，先转成日期类型
    if (typeof date === 'number') {
      date = new Date(date)
    }

    // 将日期根据格式化规则进行格式化，使用正则表达式替换
    if (date != null && date instanceof Date) {
      var o = {
        'M+': date.getMonth() + 1,
        'D+': date.getDate(),
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S': date.getMilliseconds()
      }
      var week = {
        '0': '\u65e5',
        '1': '\u4e00',
        '2': '\u4e8c',
        '3': '\u4e09',
        '4': '\u56db',
        '5': '\u4e94',
        '6': '\u516d'
      }
      if (/(Y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }
  }
  return null
}

function getFormatValue (date, fmt, key) {
  if (date && fmt && key) {
    if (fmt.indexOf(key) >= 0) {
      let start = fmt.indexOf(key)
      return parseInt(date.substr(start, key.length)) || 0
    }
  }
  return 0
}

// 对象、时间或字符串转日期
function parse (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  try {
    if (date != null) {
      if (typeof date === 'string') {
        if (date.length == fmt.length) {
          // 年
          let year = getFormatValue(date, fmt, 'YYYY')
          // 月
          let month = getFormatValue(date, fmt, 'MM') - 1
          // 日
          let day = getFormatValue(date, fmt, 'DD')
          // 时
          let hour = getFormatValue(date, fmt, 'HH')
          // 分
          let minute = getFormatValue(date, fmt, 'mm')
          // 秒
          let second = getFormatValue(date, fmt, 'ss')

          return new Date(year, month, day, hour, minute, second)
        }
      } else if (typeof date === 'number') {
        return new Date(date)
      } else if (date instanceof Date) {
        return date
      }
    }
  } catch (e) {
    console.error('格式化日期错误，date = ' + date + '，fmt = ' + fmt)
  }

  return null
}

// 时间戳
function timestamp (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (date == null) {
    date = new Date()
  }
  date = parse(date, fmt)
  return date != null ? date.getTime() : 0
}

// 今天
function today (fmt = 'YYYY-MM-DD') {
  return format(new Date(), fmt)
}

// 当前时间
function now (fmt = 'YYYY-MM-DD HH:mm:ss') {
  return format(new Date(), fmt)
}

// 日期加减
function addDays (date, days, fmt = 'YYYY-MM-DD HH:mm:ss') {
  date = parse(date, fmt)
  if (date != null) {
    days = days || 0
    date.setDate(date.getDate() + days)
    return date
  }
  return null
}

// 计算时长，如 1:23:30
function duration (timestamp) {
  // 如果是字符串类型，则转成数字
  if (typeof timestamp === 'string') {
    timestamp = parseInt(timestamp) || 0
  }
  if (typeof timestamp === 'number') {
    let hours = Math.floor((timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    let minutes = Math.floor((timestamp % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = Math.round((timestamp % (1000 * 60)) / 1000)
    if (minutes == '0') {
      minutes = '00'
    }
    if (seconds == '0') {
      seconds = '00'
    }

    if (hours.toString().length == 1) {
      hours = '0' + hours
    }
    if (minutes.toString().length == 1) {
      minutes = '0' + minutes
    }
    if (seconds.toString().length == 1) {
      seconds = '0' + seconds
    }

    if (hours == '0' || hours == '00') {
      return minutes + ':' + seconds
    } else {
      return hours + ':' + minutes + ':' + seconds
    }
  } else {
    return null
  }
}

// 计算时长--超过24小时 如48:12:12
function durationLong (timestamp) {
  if (typeof timestamp === 'string') {
    timestamp = parseInt(timestamp) || 0
  }

  const day = parseInt(timestamp / 1000 / 60 / 60 / 24)
  if (day < 1) {
    const hour = parseInt(timestamp / 1000 / 60 / 60)
    if (hour < 1) return durationShort(timestamp)

    return duration(timestamp)
  } else {
    const durationTime = duration(timestamp).split(':')
    const timeStr = durationTime.length === 3
      ? `${day * 24 + (durationTime[0] - 0)}:${durationTime[1]}:${durationTime[2]}`
      : `${day * 24}:${durationTime[0]}:${durationTime[1]}`

    return timeStr
  }
}
// 计算时长 如00:12:12
function durationShort (timestamp) {
  if (typeof timestamp === 'string') {
    timestamp = parseInt(timestamp) || 0
  }

  if (typeof timestamp === 'number') {
    let hours = Math.floor((timestamp % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    let minutes = Math.floor((timestamp % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = Math.round((timestamp % (1000 * 60)) / 1000)

    if (hours == '0') {
      hours = '00'
    }
    if (minutes == '0') {
      minutes = '00'
    }
    if (seconds == '0') {
      seconds = '00'
    }

    if (minutes.toString().length == 1) {
      minutes = '0' + minutes
    }
    if (seconds.toString().length == 1) {
      seconds = '0' + seconds
    }

    return hours + ':' + minutes + ':' + seconds
  } else {
    return null
  }
}

export default {
  // 日期格式化
  format,
  // 解析日期
  parse,
  // 计算时长
  duration,
  // 计算时长--超过24小时
  durationLong,
  // 时间戳
  timestamp,
  // 日期加减
  addDays,
  // 今天
  today,
  // 当前时间
  now,
  // 标准版
  YMDHMS: 'YYYY-MM-DD HH:mm:ss',
  YMDHM: 'YYYY-MM-DD HH:mm',
  YMD: 'YYYY-MM-DD',
  YM: 'YYYY-MM',
  MD: 'MM-DD',
  HMS: 'HH:mm:ss',
  HM: 'HH:mm',
  MDHM: 'MM-DD HH:mm',
  // 极简版
  YMDHMS_S: 'YYYYMMDDHHmmss',
  YMDHM_S: 'YYYYMMDDHHmm',
  YMD_S: 'YYYYMMDD',
  YM_S: 'YYYYMM',
  MD_S: 'MMDD',
  HMS_S: 'HHmmss',
  HM_S: 'HHmm',
  MDHM_S: 'MMDDHHmm',
  // 汉化版
  YMDHMS_CN: 'YYYY年MM月DD日 HH时mm分ss秒',
  YMDHM_CN: 'YYYY年MM月DD日 HH时mm分',
  YMD_CN: 'YYYY年MM月DD日',
  YM_CN: 'YYYY年MM月',
  MD_CN: 'MM月DD日',
  HMS_CN: 'HH时mm分ss秒',
  HM_CN: 'HH时mm分',
  MDHM_CN: 'MM月DD日 HH时mm分'
}
